import { IDiagnosisList, IDiagnosticsList } from "../../../../interfaces/patient/IDiagnosis"
import { ILabTestItem } from "../../../../interfaces/patient/IPrescriptionLabTest"
import { IPrescriptionMedicationItem } from "../../../../interfaces/patient/IPrescriptionMedication"
import { IMedicationItem } from "../../../../interfaces/patient/IMedication"
import { TableProps } from "antd/lib"
import { map } from "lodash"

export const reasonForVisitOptions = [
	{ value: "First Consult", label: "First Consult" },
	{ value: "Post CGM Consult", label: "Post CGM Consult" },
	{ value: "Q1 Consult", label: "Q1 Consult" },
	{ value: "Q2 Consult", label: "Q2 Consult" },
	{ value: "Q3 Consult", label: "Q3 Consult" },
	{ value: "Q4 Consult", label: "Q4 Consult" },
]

export enum Durations {
	DAY = "DAY",
	WEEK = "WEEK",
	MONTH = "MONTH",
	YEAR = "YEAR",
}
export const symptomsDurationOption = [
	{ label: "Day", value: Durations.DAY },
	{ label: "Week", value: Durations.WEEK },
	{ label: "Month", value: Durations.MONTH },
	{ label: "Year", value: Durations.YEAR },
]

export const getEmptyDiagnosticItem = (): IDiagnosticsList => {
	return {
		code: "",
		comment: "",
		diagnosticDetails: "",
		disease: undefined,
		provisional: false,
		updatingMethod: "",
	}
}

export const getEmptyDiagnosisItem = (): IDiagnosisList => {
	return {
		code: "",
		diagnosisType: "",
		diagnosticDetails: "",
		disease: undefined,
		updatingMethod: "",
	}
}

export const getEmptyMedicineItem = (): IMedicationItem => {
	return {
		brand: null,
		code: null,
		comments: null,
		dosage: null,
		genericName: null,
		medicineDosage: null,
		medicineQuantity: null,
		medicineType: null,
		slotList: [],
	}
}

export const getEmptyLabTestItem = (): ILabTestItem => {
	return {
		code: null,
		comments: null,
		instructions: null,
		diagnosis: {
			displayValue: null,
			internalValue: null,
			additionalInfo: {},
		},
		labTestFrequency: {
			unit: null,
			count: null,
		},
		updatingMethod: null,
	}
}

export const LabTestFrequencyOptions = [
	{
		label: "Stat",
		value: "STAT",
	},
	{ label: "Day", value: Durations.DAY },
	{ label: "Week", value: Durations.WEEK },
	{ label: "Month", value: Durations.MONTH },
]

export const LabTestInstructionOptions = [
	{ label: "Random", value: "Random" },
	{ label: "Fasting", value: "Fasting" },
]

export const getLifeStyleAdviceSuggestionsTableColumns = (): TableProps<any>["columns"] => {
	return [
		{
			title: "Display Name",
			dataIndex: "displayName",
			key: "displayName",
		},
	]
}

export const getLifeStyleAdviceSuggestionsAsTableData = (): TableProps<any>["dataSource"] => {
	return map(LifestyleAdviceSuggestions, (suggestion) => ({
		key: suggestion?.recommendation?.displayName,
		displayName: suggestion?.recommendation?.displayName,
	}))
}

export const LifestyleAdviceSuggestions = [
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 11,
			displayName: "Daily 20 minutes of personalized strength and conditioning (SnC) and muscle building, with improved daily protein consumption will help in better sugar levels.",
			name: "Daily 20 minutes of personalized strength and conditioning (SnC) and muscle building, with improved daily protein consumption will help in better sugar levels.",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "Daily 20 minutes of personalized strength and conditioning (SnC) and muscle building, with improved daily protein consumption will help in better sugar levels.",
	},
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 12,
			displayName: "Sugarfit plant based protein, 3 scoops a day, is adviced for better daily protein consumption",
			name: "Sugarfit plant based protein, 3 scoops a day, is adviced for better daily protein consumption",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "Sugarfit plant based protein, 3 scoops a day, is adviced for better daily protein consumption",
	},
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 1,
			displayName: "SMBG - Fasting alone or fasting with PPBS ( 90 min post meal - which meal)- weekly weight measurement and biweekly waist measurement.",
			name: "SMBG - Fasting alone or fasting with PPBS ( 90 min post meal - which meal)- weekly weight measurement and biweekly waist measurement.",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "SMBG - Fasting alone or fasting with PPBS ( 90 min post meal - which meal)- weekly weight measurement and biweekly waist measurement.",
	},
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 2,
			displayName: "Follow all interventions of diet and exercise as advised by your coach.",
			name: "Follow all interventions of diet and exercise as advised by your coach.",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "Follow all interventions of diet and exercise as advised by your coach.",
	},
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 3,
			displayName: "Avoid all sugary foods. Drink plenty of water. Take salads with all meals.",
			name: "Avoid all sugary foods. Drink plenty of water. Take salads with all meals.",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "Avoid all sugary foods. Drink plenty of water. Take salads with all meals.",
	},
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 4,
			displayName: "Have a good sleep hygiene (sleep 7-8 hrs at a stretch). Your coach can suggest various interventions to achieve this.",
			name: "Have a good sleep hygiene (sleep 7-8 hrs at a stretch). Your coach can suggest various interventions to achieve this.",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "Have a good sleep hygiene (sleep 7-8 hrs at a stretch). Your coach can suggest various interventions to achieve this.",
	},
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 5,
			displayName: "Take your medications daily as prescribed above. Do not miss any dosage.",
			name: "Take your medications daily as prescribed above. Do not miss any dosage.",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "Take your medications daily as prescribed above. Do not miss any dosage.",
	},
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 7,
			displayName: "Yearly retinal scan, yearly cardiac evaluation, yearly foot doctor visit is recommended to avoid complications.",
			name: "Yearly retinal scan, yearly cardiac evaluation, yearly foot doctor visit is recommended to avoid complications.",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "Yearly retinal scan, yearly cardiac evaluation, yearly foot doctor visit is recommended to avoid complications.",
	},
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 8,
			displayName: "If on insulin and facing any issues with technique or otherwise please contact your coach and they may be able to find you a resource to help with the same.",
			name: "If on insulin and facing any issues with technique or otherwise please contact your coach and they may be able to find you a resource to help with the same.",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "If on insulin and facing any issues with technique or otherwise please contact your coach and they may be able to find you a resource to help with the same.",
	},
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 9,
			displayName: "Watch on Hypoglycemia - if symptoms occur, take 2 spoons of glucose followed by a glass of fruit juice. Report to your coach immediately.",
			name: "Watch on Hypoglycemia - if symptoms occur, take 2 spoons of glucose followed by a glass of fruit juice. Report to your coach immediately.",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "Watch on Hypoglycemia - if symptoms occur, take 2 spoons of glucose followed by a glass of fruit juice. Report to your coach immediately.",
	},
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 10,
			displayName: "Blood sugars normal range before food 80-120mg/dl and 2 hours after food is 140-180mg/dl.",
			name: "Blood sugars normal range before food 80-120mg/dl and 2 hours after food is 140-180mg/dl.",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "Blood sugars normal range before food 80-120mg/dl and 2 hours after food is 140-180mg/dl.",
	},
	{
		specialit: "GP",
		userId: "GENERIC",
		userType: "GENERIC",
		context: "lifeStyleAdvices",
		recommendation: {
			index: 13,
			displayName: "Mandatorily have a doctor consultation after 4 weeks before taking any further medicine.",
			name: "Mandatorily have a doctor consultation after 4 weeks before taking any further medicine.",
			userId: "GENERIC",
			userType: "GP",
		},
		displayValue: "Mandatorily have a doctor consultation after 4 weeks before taking any further medicine.",
	},
]

export const referralStaticData = [
	{
		displayValue: "General Physician",
		internalValue: "GP_STANDARD",
	},
	{
		displayValue: "Internal Medicine",
		internalValue: "GP",
	},
	{
		displayValue: "Gynaecologist",
		internalValue: "GYNAECOLOGIST",
	},
	{
		displayValue: "Orthopaedic",
		internalValue: "ORTHOPEDIC",
	},
	{
		displayValue: "Dermatologist",
		internalValue: "DERMATOLOGIST",
	},
	{
		displayValue: "ENT",
		internalValue: "ENT",
	},
	{
		displayValue: "Sexologist",
		internalValue: "SEXOLOGIST",
	},
	{
		displayValue: "Ophthalmologist",
		internalValue: "OPHTHALMOLOGIST",
		meta: {
			comment: "Yearly Retinal eye exam to rule out Diabetic retinopathy",
		},
	},
	{
		displayValue: "Paediatrician",
		internalValue: "PEDIATRICIAN",
	},
	{
		displayValue: "Urology",
		internalValue: "UROLOGIST",
	},
	{
		displayValue: "Dental",
		internalValue: "DENTIST",
		meta: {
			comment: "Every 6 months",
		},
	},
	{
		displayValue: "Trichologist",
		internalValue: "TRICHOLOGIST",
	},
	{
		displayValue: "Psychiatry",
		internalValue: "PSYCHIATRIST",
	},
	{
		displayValue: "Pulmonology",
		internalValue: "PULMONOLOGIST",
	},
	{
		displayValue: "Gastroenterology",
		internalValue: "GASTROENTEROLOGIST",
	},
	{
		displayValue: "Endocrinology",
		internalValue: "ENDOCRINOLOGIST",
	},
	{
		displayValue: "Neurology",
		internalValue: "NEUROLOGIST",
	},
	{
		displayValue: "Cardiology",
		internalValue: "CARDIOLOGIST",
		meta: {
			comment: "Yearly ECG, ECHO and TMT with a cardiology evaluation",
		},
	},
	{
		displayValue: "Rheumatology",
		internalValue: "RHEUMATOLOGIST",
	},
	{
		displayValue: "Oncology",
		internalValue: "ONCOLOGIST",
	},
	{
		displayValue: "Nephrology",
		internalValue: "NEPHROLOGIST",
	},
	{
		displayValue: "General Surgeon",
		internalValue: "GENERAL_SURGEON",
	},
	{
		displayValue: "Gastro Surgeon",
		internalValue: "GASTRO_SURGEON",
	},
	{
		displayValue: "Plastic Surgeon",
		internalValue: "PLASTIC_SURGEON",
	},
	{
		displayValue: "Onco Surgeon",
		internalValue: "ONCO_SURGEON",
	},
	{
		displayValue: "NeuroSurgeon",
		internalValue: "NEURO_SURGEON",
	},
	{
		displayValue: "Cariac & Vascular Surgeon",
		internalValue: "CARDIAC_VASCULAR_SURGEON",
	},
	{
		displayValue: "Nutritionist/Dietician",
		internalValue: "LC",
	},
	{
		displayValue: "Physiotherapy",
		internalValue: "PHYSIOTHERAPIST",
	},
	{
		displayValue: "Therapist",
		internalValue: "MIND_THERAPIST",
	},
	{
		displayValue: "Podiatry",
		internalValue: "PODIATRY",
		meta: {
			comment: "Yearly assessment for diabetic neuropathy and circulation issues",
		},
	},
]

export const referralDefaultSuggestion = [
	{
		displayValue: "Ophthalmologist",
		internalValue: "OPHTHALMOLOGIST",
		meta: {
			comment: "Yearly Retinal eye exam to rule out Diabetic retinopathy",
		},
	},
	{
		displayValue: "Cardiology",
		internalValue: "CARDIOLOGIST",
		meta: {
			comment: "Yearly ECG, ECHO and TMT with a cardiology evaluation",
		},
	},
	{
		displayValue: "Podiatry",
		internalValue: "PODIATRY",
		meta: {
			comment: "Yearly assessment for diabetic neuropathy and circulation issues",
		},
	},
	{
		displayValue: "Dental",
		internalValue: "DENTIST",
		meta: {
			comment: "Every 6 months",
		},
	},
]
